import { Turbo } from "@hotwired/turbo-rails"

/**
 * Custom Turbo Stream action for redirecting
 *
 * Usage in controller:
 *   render turbo_stream: turbo_stream.action(:redirect_to, '', url: '/path')
 */
Turbo.StreamActions.redirect_to = function () {
  const url = this.getAttribute('url') || '/'
  Turbo.visit(url)
}
